import { useQuery } from '@tanstack/react-query'
import LocationsApi from '@/infrastructure/api/locations'

function getQueryKey() {
  return ['countries']
}

export function useCountries() {
  const countriesQuery = useQuery({
    queryKey: getQueryKey(),
    queryFn: () => LocationsApi.getCountries(),
    staleTime: Infinity
  })

  return {
    countries: countriesQuery.data ?? [],
    loadingCountries: countriesQuery.isLoading,
    reloadCountries: countriesQuery.refetch
  }
}
